import React from 'react';

function DownloadIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} fill="none" {...props}>
      <path
        fill="#0A0A0A"
        d="m14.346 17.265-3.262 3.262a5.027 5.027 0 0 1-7.11-7.108l3.261-3.265A1 1 0 0 0 5.821 8.74L2.56 12.005a7.028 7.028 0 0 0 9.94 9.936l3.262-3.262a1 1 0 0 0-1.413-1.413h-.003Z"
      />
      <path
        fill="#374957"
        d="M22.444 2.06A6.978 6.978 0 0 0 17.475 0a6.982 6.982 0 0 0-4.967 2.057L9.24 5.319a1 1 0 1 0 1.414 1.415l3.265-3.261a5.027 5.027 0 0 1 7.107 7.11l-3.262 3.26a1 1 0 0 0 1.415 1.415l3.262-3.26a7.036 7.036 0 0 0 .002-9.937Z"
      />
      <path
        fill="#374957"
        d="m14.793 8.292-5.999 6a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0-1.414-1.414Z"
      />
    </svg>
  );
}

export default DownloadIcon;
